import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initLazyloadVideo from './utils/lazyloadVideo';
import initHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initMinicart from './components/minicart';
import { initMdiCustomerTokenLogoutCleanup } from './lib/mdiCustomerToken';
import initHideRechargeInactiveTab from './components/recharge-hide-inactive-tab';

ready(() => {
  initCustomDropdowns();
  initSwiper();
  initSwiperMobile();
  initMinicart();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initMdiCustomerTokenLogoutCleanup();
  initHideRechargeInactiveTab();
});

onShopifySectionLoad(() => {
  initCustomDropdowns();
  initSwiper();
  initSwiperMobile();
  initHeader();
  initLazyloadVideo();
  initMinicart();
});
